<template>
  <div>
    <div class="row mt-4 g-3">
      <div class="col-12 col-lg-6 col-xl-3 mb-4">
        <div class="shadow rounded-1 p-3 d-flex flex-column justify-content-between" style="height: 100%">
          <div class="d-flex align-items-center">
            <span class="widget-icon me-3" style="height: auto">
              <i class="fa fa-bar-chart text-primary" />
            </span>
            <h3 class="m-0">Jumlah Perizinan</h3>
          </div>
          <p class="fs-1 mb-0 pb-0 mb-lg-4 pb-lg-4">
            {{ jumlah_laporan.jumlah_permohonan }}
          </p>
        </div>
      </div>
      <div class="col-12 col-lg-6 col-xl-3 mb-4">
        <div class="shadow rounded-1 p-3 d-flex flex-column justify-content-between" style="height: 100%">
          <div class="d-flex align-items-center">
            <span class="widget-icon me-3" style="height: auto">
              <i class="fa fa-file-text-o text-primary" />
            </span>
            <h3 class="m-0">Laporan Telah Disampaikan</h3>
          </div>
          <p class="fs-1 mb-0 pb-0 mb-lg-4 pb-lg-4">
            {{ jumlah_laporan.laporan_yang_telah_disampaikan }}
          </p>
        </div>
      </div>
      <div class="col-12 col-lg-6 col-xl-3 mb-4">
        <div class="shadow rounded-1 p-3 d-flex flex-column justify-content-between" style="height: 100%">
          <div class="d-flex align-items-center">
            <span class="widget-icon me-3" style="height: auto">
              <i class="fa fa-refresh text-primary" />
            </span>
            <h3 class="m-0">Laporan Belum Disampaikan</h3>
          </div>
          <p class="fs-1 mb-0 pb-0 mb-lg-4 pb-lg-4">
            {{ jumlah_laporan.laporan_yang_belum_disampaikan }}
          </p>
        </div>
      </div>
      <div class="col-12 col-lg-6 col-xl-3 mb-4">
        <div class="shadow rounded-1 p-3 d-flex flex-column justify-content-between" style="height: 100%">
          <div class="d-flex align-items-center">
            <span class="widget-icon me-3" style="height: auto">
              <i class="fa fa-check-square text-primary" />
            </span>
            <h3 class="m-0">Laporan Telah Dinilai</h3>
          </div>
          <p class="fs-1 mb-0 pb-0 mb-lg-4 pb-lg-4">
            {{ jumlah_laporan.laporan_yang_telah_dinilai }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: ['filterTahun', 'filterBulan'],
  data() {
    return {
      baseapiPengendalian: localStorage.getItem('baseapiPengendalian'),
      user: JSON.parse(localStorage.getItem('userPengendalian')),
      jumlah_laporan: {
        jumlah_permohonan: 0,
        laporan_yang_telah_disampaikan: 0,
        laporan_yang_belum_disampaikan: 0,
        laporan_yang_telah_dinilai: 0,
      },
    }
  },
  methods: {
    async getCountPemohon() {
      try {
        const res = await axios.get(`${this.baseapiPengendalian}api/dashboard/getCountPemohon?tahun=${this.filterTahun}&bulan=${this.filterBulan}`, {
          headers: {
            Authorization: `Bearer ` + this.user.accessToken,
          },
        })
        this.jumlah_laporan = res.data.data
      } catch (error) {}
    },
  },
  watch: {
    filterTahun: {
      handler(val) {
        this.getCountPemohon()
      },
      immediate: true,
    },
    filterBulan() {
      this.getCountPemohon()
    },
  },
}
</script>
